export type ActionButtonMessages = {
  createButton: string;
  updateButton: string;
  removeButton: string;
  cancelButton: string;
  confirmButton: string;
  continueButton: string;
  backButton: string;
  addButton: string;
  printButtonLabel: string;
  filterButton: string;
  deleteButton: string;
  includeButton: string;
  exitButton: string;
  uploadButton: string;
};

export const ACTION_BUTTON_MESSAGES = {
  createButton: "Criar",
  updateButton: "Salvar",
  removeButton: "Excluir",
  cancelButton: "Cancelar",
  confirmButton: "Confirmar",
  continueButton: "Avançar",
  backButton: "Voltar",
  addButton: "Adicionar",
  printButtonLabel: "Imprimir",
  filterButton: "Filtrar",
  deleteButton: "Deletar",
  includeButton: "Incluir",
  exitButton: "Sair",
  uploadButton: "Fazer Upload",
};
